import React from 'react';
import { Link, useLocation } from 'react-router-dom';

/**
 * RelatedServicesNav
 * Reusable pill-style navigation across all veterinary SEO landing pages.
 * Renders standard anchor tags (via react-router Link) for crawlability.
 * Highlights the active page based on current pathname.
 */
const LINKS = [
  { to: '/veterinary-clinic-noida', label: 'Veterinary Clinic Noida' },
  { to: '/dog-vet-noida',           label: 'Dog Vet Noida' },
  { to: '/cat-vet-noida',           label: 'Cat Vet Noida' },
  { to: '/pet-doctor-noida',        label: 'Pet Doctor Noida' },
  { to: '/pet-vaccination-noida',   label: 'Pet Vaccination Noida' },
  { to: '/puppy-vaccination-noida', label: 'Puppy Vaccination Noida' },
  { to: '/kitten-vaccination-noida',label: 'Kitten Vaccination Noida' },
  { to: '/pet-surgery-noida',       label: 'Pet Surgery Noida' },
  { to: '/spaying-surgery-noida',   label: 'Spaying Surgery Noida' },
  { to: '/neutering-surgery-noida', label: 'Neutering Surgery Noida' },
  { to: '/pet-x-ray-noida',         label: 'Pet X-Ray Noida' },
  { to: '/pet-diagnostics-noida',   label: 'Pet Diagnostics Noida' },
];

const RelatedServicesNav = ({ current }) => {
  const location = useLocation();
  const activePath = current || location.pathname;

  return (
    <nav
      aria-label="Explore related veterinary services in Noida"
      data-testid="related-services-nav"
      className="bg-white border-b border-[#f3d6f5]/60"
    >
      <div className="max-w-[1200px] mx-auto px-5 sm:px-8 lg:px-10 py-6 sm:py-8">
        <p className="text-[11px] font-bold tracking-[0.28em] text-[#5b3eb5] mb-4 text-center">
          EXPLORE RELATED VETERINARY SERVICES
        </p>
        <ul className="flex flex-wrap justify-center gap-2 sm:gap-2.5">
          {LINKS.map((l) => {
            const isActive = l.to === activePath;
            return (
              <li key={l.label}>
                <Link
                  to={l.to}
                  aria-current={isActive ? 'page' : undefined}
                  data-testid={`related-nav-${l.to.replace(/\//g, '') || 'root'}${isActive ? '-active' : ''}`}
                  className={
                    isActive
                      ? 'inline-flex items-center px-4 py-2 rounded-full text-[13px] font-semibold bg-[#1a0b3d] text-white border border-[#1a0b3d] shadow-sm cursor-default pointer-events-none focus:outline-none focus-visible:ring-2 focus-visible:ring-[#e870b6] focus-visible:ring-offset-2 transition-colors'
                      : 'inline-flex items-center px-4 py-2 rounded-full text-[13px] font-semibold bg-[#fdf7fb] text-[#1a0b3d] border border-[#f3d6f5] hover:border-[#e870b6] hover:bg-white hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-[#e870b6] focus-visible:ring-offset-2 transition-all'
                  }
                >
                  {l.label}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
};

export default RelatedServicesNav;
